import { PlainBase64Adapter } from "@/core/common/helpers/adapters/PlainBase64Adapter";
import {
  IPlainBase64,
  PlainBase64DI
} from "@/core/common/helpers/ports/PlainBase64";
import { ContainerModule } from "inversify";

const helpersContainer = new ContainerModule((bind) => {
  bind<IPlainBase64>(PlainBase64DI).to(PlainBase64Adapter).inSingletonScope();
});

export { helpersContainer };
